export enum OfferStatus {
    Started = 'started',
    Expired = 'expired',
    Completed = 'completed'
}